import hellojs from '../../vendor/hello.js'

export default function () {
  return hellojs
    // install Clio driver
    .init({
      clio: {
        name: 'Clio',

        base: 'https://app.clio.com/',

        oauth: {
          version: 2,
          auth: 'https://app.clio.com/oauth/authorize',
          grant: 'https://app.clio.com/oauth/token',
          response_type: 'code',
        },

        login(p) {
          // sets popup size to fit the Clio login screen
          p.options.popup.width = 1024;
          p.options.popup.height = 730;
        },
      }
    })

    // Initialize Driver instance
    .init(
      { clio: window.Drupal.settings.INTEGRATIONS_CLIO_APP_ID },
      {
        redirect_uri: 'https://app.courtdrive.com/rpc/static/hello.js/redirect.html',
        oauth_proxy: `${window.location.origin}/rpc/integrations/oauth_proxy`,
      }
    )('clio'); // spawn an instance of the driver that one can call .login() on
}



// WEBPACK FOOTER //
// ./src/Integrations/connections/ClioAuthenticator.jsx